export const contactDetails = {
  brandName: "Sharda Agrotech",
  tagline: "Fresh. Pure. Trusted.",
  logoPath: "/assets/sharda-logo.jpg",
  phoneDisplay: "+91-9575509777",
  phoneRaw: "919575509777",
  whatsappDisplay: "+91-9575509777",
  email: "shardaagrotech@outlook.com",
  address: "Village Khainda, Baloda Bazar, Chhattisgarh (493332)",
  whatsappLink: "https://wa.me/919575509777",
  phoneLink: "tel:+919575509777",
  emailLink: "mailto:shardaagrotech@outlook.com",
};

export const imageAssets = {
  hero:
    "https://static.prod-images.emergentagent.com/jobs/37158be3-7fb1-4d93-b8e3-abcd832b46db/images/035b5c4325fe337207d3392c96d7c1fd7cc79d011300902eb062816cc7767cdc.png",
  mushrooms:
    "https://static.prod-images.emergentagent.com/jobs/37158be3-7fb1-4d93-b8e3-abcd832b46db/images/aa807fc968dbab2ddc163c5c6a7f29cf9a2ffa9ce50e13272c37a9a15b2b60e3.png",
  spawn:
    "https://static.prod-images.emergentagent.com/jobs/37158be3-7fb1-4d93-b8e3-abcd832b46db/images/001ed8270c93b2195e07fe825d66f688e7f039727695b281c987ecc6b7f9cfab.png",
  compost:
    "https://images.unsplash.com/photo-1569880153113-76e33fc52d5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxzb2lsJTIwY29tcG9zdHxlbnwwfHx8fDE3NzgwNjU5NDV8MA&ixlib=rb-4.1.0&q=85",
};

export const productOptions = [
  { value: "Fresh Mushrooms", slug: "fresh-mushrooms", labelEn: "Fresh Mushrooms", labelHi: "ताज़े मशरूम" },
  { value: "Mushroom Spawn", slug: "mushroom-spawn", labelEn: "Mushroom Spawn", labelHi: "मशरूम स्पॉन" },
  { value: "Premium Compost", slug: "premium-compost", labelEn: "Premium Compost", labelHi: "प्रीमियम कम्पोस्ट" },
  { value: "Value-Added Products (Coming Soon)", slug: "value-added-products", labelEn: "Value-Added Products (Coming Soon)", labelHi: "वैल्यू-एडेड उत्पाद (जल्द आ रहा है)" },
];

export const siteContent = {
  en: {
    locale: "en",
    topBar:
      "Fresh Mushroom Supply, Spawn & Premium Compost for Business Buyers",
    nav: [
      { label: "Home", href: "/" },
      { label: "Products", href: "/products" },
      { label: "Wholesale", href: "/wholesale" },
      { label: "About", href: "/about" },
      { label: "Process", href: "/process" },
      { label: "Blog", href: "/blog" },
      { label: "Contact", href: "/contact" },
    ],
    ctas: {
      requestQuote: "Inquiry Form",
      whatsapp: "Chat on WhatsApp",
      call: "Call Now",
      exploreProducts: "Explore Products",
      tellRequirement: "Tell Us Your Requirement",
      inquiryOnly: "Request an Inquiry",
      readArticle: "Read article",
      visitProduct: "View details",
      submitQuote: "Submit Inquiry",
      submitContact: "Send Message",
      seeAllArticles: "See all articles",
    },
    hero: {
      eyebrow: "Fresh supply • trusted quality • scientific care",
      title: "Reliable Fresh Mushroom Supply, Spawn & Premium Compost",
      description:
        "Sharda Agrotech brings together farm-fresh mushroom supply, trusted quality, and research-led cultivation to serve restaurants, hotels, caterers, wholesalers, and growers with confidence.",
      trustChips: ["FSSAI Licensed", "Trusted Quality", "Scientific Care"],
      trustLine: ["Fresh mushroom supply", "Trusted quality", "Scientific cultivation"],
      metrics: [
        { label: "Product lines", value: "3 core categories" },
        { label: "Supply model", value: "Direct farm communication" },
        { label: "Promise", value: "Farm-to-table freshness" },
      ],
    },
    trustBar: [
      { title: "Direct Farm Supply", text: "Fresh mushrooms handled with care and supplied directly from our farm." },
      { title: "FSSAI Licensed", text: "Quality you can trust, backed by food-safety confidence." },
      { title: "Inquiry Support", text: "Clear, requirement-based support for serious buyers and repeat supply needs." },
      { title: "Science-Backed Approach", text: "Research-led cultivation and handling for consistent product quality." },
    ],
    buyerTypes: [
      "Restaurants",
      "Hotels",
      "Caterers",
      "Wholesalers / Distributors",
      "Mushroom Growers",
    ],
    featuredProducts: [
      {
        title: "Fresh Mushrooms",
        slug: "fresh-mushrooms",
        image: imageAssets.mushrooms,
        summary: "Naturally fresh, premium mushrooms with a clean farm-picked feel for kitchens, retailers, and wholesale buyers.",
      },
      {
        title: "Mushroom Spawn",
        slug: "mushroom-spawn",
        image: imageAssets.spawn,
        summary: "Scientific, lab-quality spawn prepared for growers who need dependable cultivation inputs and consistency.",
      },
      {
        title: "Premium Compost",
        slug: "premium-compost",
        image: imageAssets.compost,
        summary: "Nutrient-rich, in-house compost suitable for mushroom cultivation and organic farming.",
      },
      {
        title: "Value-Added Products",
        slug: "value-added-products",
        image: "https://images.unsplash.com/photo-1731390210280-3ad87c6af215?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxidXR0b24lMjBtdXNocm9vbXMlMjBsaWdodCUyMGJhY2tncm91bmQlMjBtaW5pbWFsfGVufDB8fHx8MTc3ODA2OTA0OXww&ixlib=rb-4.1.0&q=85",
        summary: "Premium value-added mushroom products are launching soon for buyers who want an expanded product range.",
      },
    ],
    whyChooseUs: [
      "Grown with Care",
      "Direct Communication",
      "Fresh Supply Focus",
      "Multiple Product Categories",
      "Food Safety Confidence",
      "Backed by Expertise",
    ],
    about: {
      title: "Fresh supply rooted in trust and scientific cultivation",
      intro:
        "Sharda Agrotech is a family-owned mushroom farm in the heart of Chhattisgarh, known for naturally fresh produce, dependable quality, and research-led cultivation practices.",
      supporting:
        "From premium mushrooms to quality spawn and compost, our focus on freshness, trust, and scientific care helps us serve buyers who value direct communication and consistent supply.",
    },
    founder: {
      name: "Dr. Ashish Dadsena",
      title: "PhD (Biotech), MSc (Biotech)",
      description:
        "With vast teaching and research experience in the field, Dr. Ashish Dadsena brings strong scientific knowledge, technical expertise, and a research-driven approach to mushroom cultivation, quality, and sustainable agricultural practices.",
    },
    mission:
      "To deliver farm-fresh, chemical-free mushrooms and premium compost to every household and business, while empowering local farmers through sustainable practices.",
    vision:
      "To become Central India's most trusted name in mushroom farming and organic compost — built on purity, quality, and trust.",
    processIntro: "From compost to your kitchen — step by step",
    processSteps: [
      { title: "Composting", text: "We prepare rich, in-house compost as the foundation for healthy, reliable mushroom growth." },
      { title: "Spawning", text: "Quality spawn is introduced with care to support clean, consistent colonisation." },
      { title: "Growing", text: "Controlled growing conditions help us maintain freshness, uniformity, and buyer-ready quality." },
      { title: "Harvesting", text: "Mushrooms are hand-selected at the right stage for appearance, texture, and freshness." },
      { title: "Delivery / Dispatch", text: "Orders are packed thoughtfully for smooth dispatch and direct buyer coordination." },
    ],
    wholesale: {
      title: "Premium fresh mushroom supply backed by scientific reliability",
      description:
        "Whether you source for restaurants, hotels, caterers, wholesalers, or growers, Sharda Agrotech combines premium farm supply with research-led consistency and direct inquiry support.",
      benefits: [
        "No public pricing — every inquiry is matched to your actual requirement",
        "Premium product quality supported by scientific cultivation and handling",
        "Simple coordination through phone, WhatsApp, and inquiry forms",
      ],
    },
    quoteForm: {
      title: "Inquiry form",
      description: "Share your requirement and our team will reach out with the right supply details.",
      fields: {
        name: "Name",
        company: "Company / Business Name",
        phone: "Phone Number",
        email: "Email Address",
        product: "Product Interested In",
        quantity: "Quantity Requirement",
        message: "Message",
      },
      placeholders: {
        name: "Your full name",
        company: "Restaurant, hotel, trading firm, grower, etc.",
        phone: "Enter phone number",
        email: "Enter email address",
        quantity: "Eg. 25 kg per week / 200 bags / monthly bulk",
        message: "Tell us about product type, expected quantity, and timing.",
      },
      success: "Thank you — your request has been received.",
      error: "Something went wrong. Please try again.",
    },
    testimonialsTitle: "What people say",
    testimonials: [
      {
        quote:
          "Sharda Agrotech's mushrooms are always fresh and of consistent quality. They're our go-to supplier for all mushroom dishes.",
        name: "Shankar",
        role: "Baloda Bazar",
      },
      {
        quote:
          "The button mushrooms are so fresh — you can taste the difference. I order regularly for my family's meals.",
        name: "Gulab Singh Thakur",
        role: "Home Cook, Raipur",
      },
      {
        quote:
          "Their compost quality is excellent. It has significantly improved my crop yield. Highly recommended for farmers.",
        name: "Sunidhi Bansal",
        role: "Organic Farmer",
      },
    ],
    blog: {
      title: "Blog & resources",
      description: "Practical guides for kitchens, growers, and wholesale buyers looking to work smarter.",
    },
    footerText:
      "Growing fresh mushrooms, premium spawn, and nutrient-rich compost in Chhattisgarh for trusted business supply.",
    productsPage: {
      title: "Fresh mushrooms, scientific spawn, and premium cultivation essentials",
      description: "Explore naturally fresh mushrooms, lab-quality spawn, and premium compost — with inquiry-first support and no public pricing.",
    },
    aboutPage: {
      title: "Fresh, trusted, and guided by scientific cultivation",
      description: "Sharda Agrotech blends natural freshness, dependable trust, and research-led farming into a supply experience built for serious buyers.",
      highlights: [
        "Fresh mushroom supply handled with care",
        "Research-led cultivation standards",
        "Direct communication for dependable sourcing",
      ],
    },
    processPage: {
      title: "A careful process built for freshness and consistency",
      description: "Every stage — from compost to dispatch — is designed to protect quality, build trust, and support dependable supply.",
      highlights: [
        "In-house compost preparation",
        "Clean spawning workflow",
        "Controlled growing conditions",
        "Buyer-ready harvesting and dispatch",
      ],
    },
    contactPage: {
      title: "Get in touch",
      description: "We’d love to hear from you — call, WhatsApp, email, or share your requirement and our team will guide you with care.",
    },
  },
  hi: {
    locale: "hi",
    topBar:
      "व्यावसायिक खरीदारों के लिए ताज़े मशरूम, स्पॉन और प्रीमियम कम्पोस्ट की सप्लाई",
    nav: [
      { label: "होम", href: "/" },
      { label: "उत्पाद", href: "/products" },
      { label: "थोक सप्लाई", href: "/wholesale" },
      { label: "हमारे बारे में", href: "/about" },
      { label: "प्रक्रिया", href: "/process" },
      { label: "ब्लॉग", href: "/blog" },
      { label: "संपर्क", href: "/contact" },
    ],
    ctas: {
      requestQuote: "पूछताछ फ़ॉर्म",
      whatsapp: "व्हाट्सऐप पर बात करें",
      call: "अभी कॉल करें",
      exploreProducts: "उत्पाद देखें",
      tellRequirement: "अपनी आवश्यकता बताइए",
      inquiryOnly: "पूछताछ भेजें",
      readArticle: "लेख पढ़ें",
      visitProduct: "विवरण देखें",
      submitQuote: "पूछताछ भेजें",
      submitContact: "संदेश भेजें",
      seeAllArticles: "सभी लेख देखें",
    },
    hero: {
      eyebrow: "ताज़ी सप्लाई • भरोसेमंद गुणवत्ता • वैज्ञानिक देखभाल",
      title: "ताज़े मशरूम, स्पॉन और प्रीमियम कम्पोस्ट की भरोसेमंद सप्लाई",
      description:
        "Sharda Agrotech ताज़ी मशरूम सप्लाई, भरोसेमंद गुणवत्ता और रिसर्च-आधारित खेती को साथ लाकर रेस्टोरेंट, होटल, कैटरर, थोक खरीदारों और ग्रोअर्स की सेवा करता है।",
      trustChips: ["FSSAI Licensed", "भरोसेमंद गुणवत्ता", "वैज्ञानिक देखभाल"],
      trustLine: ["ताज़ी मशरूम सप्लाई", "भरोसेमंद गुणवत्ता", "वैज्ञानिक खेती"],
      metrics: [
        { label: "उत्पाद श्रेणियाँ", value: "3 मुख्य कैटेगरी" },
        { label: "सप्लाई मॉडल", value: "सीधा फार्म संवाद" },
        { label: "हमारा वादा", value: "फ़ार्म-टू-टेबल ताज़गी" },
      ],
    },
    trustBar: [
      { title: "सीधी फार्म सप्लाई", text: "ताज़े मशरूम सावधानी के साथ सीधे हमारे फार्म से सप्लाई किए जाते हैं।" },
      { title: "FSSAI Licensed", text: "भोजन सुरक्षा भरोसे के साथ ऐसी गुणवत्ता जिस पर आप विश्वास कर सकें।" },
      { title: "पूछताछ सहायता", text: "गंभीर खरीदारों और नियमित सप्लाई जरूरतों के लिए स्पष्ट सहायता।" },
      { title: "वैज्ञानिक दृष्टिकोण", text: "स्थिर गुणवत्ता के लिए रिसर्च-आधारित खेती और हैंडलिंग।" },
    ],
    buyerTypes: ["रेस्टोरेंट", "होटल", "कैटरर्स", "थोक विक्रेता / डिस्ट्रीब्यूटर", "मशरूम ग्रोअर्स"],
    featuredProducts: [
      {
        title: "ताज़े मशरूम",
        slug: "fresh-mushrooms",
        image: imageAssets.mushrooms,
        summary: "प्राकृतिक ताज़गी और प्रीमियम गुणवत्ता वाले मशरूम — किचन, रिटेल और थोक खरीदारों के लिए।",
      },
      {
        title: "मशरूम स्पॉन",
        slug: "mushroom-spawn",
        image: imageAssets.spawn,
        summary: "वैज्ञानिक और लैब-क्वालिटी स्पॉन — उन ग्रोअर्स के लिए जिन्हें स्थिर और भरोसेमंद खेती इनपुट चाहिए।",
      },
      {
        title: "प्रीमियम कम्पोस्ट",
        slug: "premium-compost",
        image: imageAssets.compost,
        summary: "मशरूम खेती और ऑर्गेनिक फार्मिंग के लिए पोषक तत्वों से भरपूर इन-हाउस कम्पोस्ट।",
      },
      {
        title: "वैल्यू-एडेड उत्पाद",
        slug: "value-added-products",
        image: "https://images.unsplash.com/photo-1731390210280-3ad87c6af215?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxidXR0b24lMjBtdXNocm9vbXMlMjBsaWdodCUyMGJhY2tncm91bmQlMjBtaW5pbWFsfGVufDB8fHx8MTc3ODA2OTA0OXww&ixlib=rb-4.1.0&q=85",
        summary: "प्रीमियम वैल्यू-एडेड मशरूम उत्पाद जल्द लॉन्च होंगे — उन खरीदारों के लिए जो विस्तृत रेंज चाहते हैं।",
      },
    ],
    whyChooseUs: [
      "सावधानी से उगाया गया",
      "सीधा संवाद",
      "ताज़ी सप्लाई पर फोकस",
      "अनेक उत्पाद श्रेणियाँ",
      "फूड सेफ्टी भरोसा",
      "विशेषज्ञता का साथ",
    ],
    about: {
      title: "ताज़ी सप्लाई, भरोसा और वैज्ञानिक खेती पर आधारित ब्रांड",
      intro:
        "Sharda Agrotech छत्तीसगढ़ के हृदय में स्थित एक पारिवारिक मशरूम फार्म है, जो प्राकृतिक ताज़गी, भरोसेमंद गुणवत्ता और रिसर्च-आधारित खेती के लिए जाना जाता है।",
      supporting:
        "प्रीमियम मशरूम, क्वालिटी स्पॉन और कम्पोस्ट के साथ, हमारा फोकस ताज़गी, भरोसे और वैज्ञानिक देखभाल पर है — ताकि खरीदारों को स्थिर सप्लाई और सीधा संवाद मिल सके।",
    },
    founder: {
      name: "डॉ. आशीष ददसेना",
      title: "पीएचडी (बायोटेक), एमएससी (बायोटेक)",
      description:
        "शिक्षण और शोध के व्यापक अनुभव के साथ, डॉ. आशीष ददसेना मशरूम खेती, गुणवत्ता और टिकाऊ कृषि पद्धतियों में मजबूत वैज्ञानिक ज्ञान, तकनीकी विशेषज्ञता और शोध-आधारित दृष्टिकोण लाते हैं।",
    },
    mission:
      "हर घर और व्यवसाय तक फ़ार्म-फ्रेश, रसायन-मुक्त मशरूम और प्रीमियम कम्पोस्ट पहुँचाना, साथ ही टिकाऊ प्रथाओं के माध्यम से स्थानीय किसानों को सशक्त बनाना।",
    vision:
      "शुद्धता, गुणवत्ता और भरोसे पर आधारित, मध्य भारत में मशरूम खेती और ऑर्गेनिक कम्पोस्ट का सबसे विश्वसनीय नाम बनना।",
    processIntro: "कम्पोस्ट से आपकी रसोई तक — चरण दर चरण",
    processSteps: [
      { title: "कम्पोस्टिंग", text: "हम समृद्ध, इन-हाउस कम्पोस्ट तैयार करते हैं जो स्वस्थ और भरोसेमंद मशरूम विकास की नींव बनता है।" },
      { title: "स्पॉनिंग", text: "गुणवत्ता वाले स्पॉन को सावधानी से मिलाया जाता है ताकि स्वच्छ और स्थिर विकास सुनिश्चित हो।" },
      { title: "ग्रोइंग", text: "नियंत्रित वातावरण ताज़गी, एकरूपता और खरीदार-योग्य गुणवत्ता बनाए रखने में मदद करता है।" },
      { title: "हार्वेस्टिंग", text: "मशरूम को सही अवस्था पर हाथ से चुना जाता है ताकि रूप, बनावट और ताज़गी बनी रहे।" },
      { title: "डिलीवरी / डिस्पैच", text: "ऑर्डर सोच-समझकर पैक किए जाते हैं ताकि डिस्पैच आसान हो और खरीदार से सीधा समन्वय बना रहे।" },
    ],
    wholesale: {
      title: "वैज्ञानिक भरोसे के साथ प्रीमियम ताज़ा मशरूम सप्लाई",
      description:
        "चाहे आप रेस्टोरेंट, होटल, कैटरर, थोक खरीदार या ग्रोअर हों, Sharda Agrotech प्रीमियम फार्म सप्लाई को रिसर्च-आधारित स्थिरता और सीधी पूछताछ सहायता के साथ जोड़ता है।",
      benefits: [
        "कोई सार्वजनिक कीमत नहीं — हर पूछताछ आपकी वास्तविक आवश्यकता के अनुसार संभाली जाती है",
        "वैज्ञानिक खेती और हैंडलिंग के साथ प्रीमियम गुणवत्ता",
        "फोन, व्हाट्सऐप और पूछताछ फ़ॉर्म के माध्यम से सरल समन्वय",
      ],
    },
    quoteForm: {
      title: "पूछताछ फ़ॉर्म",
      description: "अपनी आवश्यकता साझा करें, हमारी टीम आपसे सही सप्लाई विवरण के साथ संपर्क करेगी।",
      fields: {
        name: "नाम",
        company: "कंपनी / व्यवसाय का नाम",
        phone: "फोन नंबर",
        email: "ईमेल पता",
        product: "रुचि वाला उत्पाद",
        quantity: "मात्रा की आवश्यकता",
        message: "संदेश",
      },
      placeholders: {
        name: "अपना पूरा नाम लिखें",
        company: "रेस्टोरेंट, होटल, ट्रेडिंग फर्म, ग्रोअर आदि",
        phone: "फोन नंबर लिखें",
        email: "ईमेल पता लिखें",
        quantity: "जैसे 25 किलो प्रति सप्ताह / 200 बैग / मासिक थोक",
        message: "उत्पाद, मात्रा और समय के बारे में बताइए।",
      },
      success: "धन्यवाद — आपका अनुरोध प्राप्त हो गया है।",
      error: "कुछ गड़बड़ हो गई। कृपया दोबारा प्रयास करें।",
    },
    testimonialsTitle: "लोग क्या कहते हैं",
    testimonials: [
      {
        quote:
          "Sharda Agrotech के मशरूम हमेशा ताज़े और एक जैसी गुणवत्ता वाले होते हैं। मशरूम डिशेज़ के लिए यही हमारी पहली पसंद है।",
        name: "शंकर",
        role: "बलौदा बाज़ार",
      },
      {
        quote:
          "बटन मशरूम इतने ताज़े होते हैं कि फर्क स्वाद में महसूस होता है। मैं अपने परिवार के लिए नियमित रूप से ऑर्डर करता हूँ।",
        name: "गुलाब सिंह ठाकुर",
        role: "होम कुक, रायपुर",
      },
      {
        quote:
          "इनके कम्पोस्ट की गुणवत्ता बहुत अच्छी है। इससे मेरी फसल की उपज काफी बेहतर हुई है। किसानों के लिए बेहद उपयोगी।",
        name: "सुनिधि बंसल",
        role: "ऑर्गेनिक किसान",
      },
    ],
    blog: {
      title: "ब्लॉग और संसाधन",
      description: "किचन, ग्रोअर्स और थोक खरीदारों के लिए उपयोगी गाइड और सुझाव।",
    },
    footerText:
      "छत्तीसगढ़ में भरोसेमंद व्यावसायिक सप्लाई के लिए ताज़े मशरूम, प्रीमियम स्पॉन और पोषक तत्वों से भरपूर कम्पोस्ट।",
    productsPage: {
      title: "ताज़े मशरूम, वैज्ञानिक स्पॉन और प्रीमियम खेती समाधान",
      description: "प्राकृतिक ताज़े मशरूम, लैब-क्वालिटी स्पॉन और प्रीमियम कम्पोस्ट देखें — बिना सार्वजनिक कीमत के, केवल पूछताछ आधारित सहायता के साथ।",
    },
    aboutPage: {
      title: "ताज़गी, भरोसा और वैज्ञानिक खेती से बना मजबूत ब्रांड",
      description: "Sharda Agrotech प्राकृतिक ताज़गी, भरोसेमंद गुणवत्ता और रिसर्च-आधारित खेती को जोड़कर गंभीर खरीदारों के लिए भरोसेमंद सप्लाई अनुभव देता है।",
      highlights: [
        "सावधानी से संभाली गई ताज़ी मशरूम सप्लाई",
        "रिसर्च-आधारित खेती मानक",
        "भरोसेमंद सोर्सिंग के लिए सीधा संवाद",
      ],
    },
    processPage: {
      title: "ताज़गी और स्थिरता के लिए बनाया गया सावधानीपूर्ण प्रोसेस",
      description: "कम्पोस्ट से डिस्पैच तक हर चरण गुणवत्ता की रक्षा, भरोसा बनाने और स्थिर सप्लाई देने के लिए तैयार किया गया है।",
      highlights: [
        "इन-हाउस कम्पोस्ट तैयारी",
        "स्वच्छ स्पॉनिंग प्रक्रिया",
        "नियंत्रित ग्रोइंग कंडीशन्स",
        "खरीदार-तैयार हार्वेस्टिंग और डिस्पैच",
      ],
    },
    contactPage: {
      title: "संपर्क करें",
      description: "हमें आपसे सुनकर खुशी होगी — कॉल करें, व्हाट्सऐप करें, ईमेल भेजें या अपनी आवश्यकता लिखें, हमारी टीम पूरी देखभाल के साथ मार्गदर्शन करेगी।",
    },
  },
};

export const productDetails = {
  en: {
    "fresh-mushrooms": {
      title: "Fresh Mushrooms",
      image: imageAssets.mushrooms,
      description:
        "Naturally fresh, premium mushrooms with a clean farm-picked feel for curries, soups, pizzas, salads, and quality-focused kitchens.",
      highlights: [
        "Farm-fresh and carefully harvested",
        "Suitable for restaurants, hotels, caterers, and wholesalers",
        "FSSAI Licensed trust signal",
      ],
      useCases: ["Curries & gravies", "Continental dishes", "Retail and family kitchens", "Wholesale supply"],
    },
    "mushroom-spawn": {
      title: "Mushroom Spawn",
      image: imageAssets.spawn,
      description:
        "Scientific, lab-quality spawn for Button and Oyster varieties, prepared for growers who need dependable inputs and consistent cultivation support.",
      highlights: [
        "Lab-grade quality positioning",
        "Useful for commercial growers and hobby growers",
        "Bulk inquiries supported",
      ],
      useCases: ["Commercial cultivation", "Pilot mushroom units", "Grower trials", "Repeat bulk requirements"],
    },
    "premium-compost": {
      title: "Premium Compost",
      image: imageAssets.compost,
      description:
        "Nutrient-rich compost made in-house for mushroom cultivation and broader organic farming needs, with consistent quality for business buyers.",
      highlights: [
        "Prepared in-house",
        "Suitable for cultivation use cases",
        "Bulk supply available on inquiry",
      ],
      useCases: ["Mushroom cultivation", "Farm input planning", "Organic farming", "Wholesale supply"],
    },
  },
  hi: {
    "fresh-mushrooms": {
      title: "ताज़े मशरूम",
      image: imageAssets.mushrooms,
      description:
        "प्राकृतिक ताज़गी और प्रीमियम गुणवत्ता वाले मशरूम — करी, सूप, पिज़्ज़ा, सलाद और गुणवत्ता-आधारित किचन के लिए।",
      highlights: ["फ़ार्म-फ्रेश और सावधानी से चुने गए", "रेस्टोरेंट, होटल, कैटरर और थोक खरीदारों के लिए उपयुक्त", "FSSAI Licensed भरोसा"],
      useCases: ["करी और ग्रेवी", "कॉन्टिनेंटल डिश", "रिटेल और परिवार की रसोई", "थोक सप्लाई"],
    },
    "mushroom-spawn": {
      title: "मशरूम स्पॉन",
      image: imageAssets.spawn,
      description:
        "Button और Oyster किस्मों के लिए वैज्ञानिक और लैब-क्वालिटी स्पॉन, उन ग्रोअर्स के लिए जो भरोसेमंद इनपुट और स्थिर खेती समर्थन चाहते हैं।",
      highlights: ["लैब-ग्रेड क्वालिटी पोजिशनिंग", "कमर्शियल और छोटे ग्रोअर्स दोनों के लिए उपयोगी", "थोक पूछताछ समर्थित"],
      useCases: ["कमर्शियल खेती", "पायलट यूनिट", "ग्रोअर ट्रायल्स", "दोबारा थोक आवश्यकता"],
    },
    "premium-compost": {
      title: "प्रीमियम कम्पोस्ट",
      image: imageAssets.compost,
      description:
        "मशरूम खेती और व्यापक ऑर्गेनिक फार्मिंग जरूरतों के लिए इन-हाउस तैयार पोषक तत्वों से भरपूर कम्पोस्ट।",
      highlights: ["इन-हाउस तैयार", "खेती उपयोग के लिए उपयुक्त", "पूछताछ पर थोक सप्लाई उपलब्ध"],
      useCases: ["मशरूम खेती", "फार्म इनपुट योजना", "ऑर्गेनिक फार्मिंग", "थोक सप्लाई"],
    },
  },
};